// removed by extract-text-webpack-plugin
module.exports = {"container":"container_1op2b","svg":"svg_2CRi0","header":"header_hfEMU","cells":"cells_2TtAC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/gameboard/style.scss
// module id = 524
// module chunks = 0